import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../context/DataContext';
const Nextreservation = () => {
    const {setNavtrans} = useContext(DataContext);
useEffect(() => {
    setNavtrans(false);
})
    return (
    <div className='container'>
        <div className='tripsschedul' style={{width:"40%"}}>
            <div style={{margin:'0px'}}>الموعد الحالي</div>
            <hr style={{width:'100%',marginTop:'5px',marginBottom:'5px'}}/>
            <div className='trip'>
                <div className='trip'
                    style={{flexDirection:'column',justifyContent:'space-evenly',height:'180px'}}>
                        <img src='' alt='2' />
                    <div className='tripitem hov'>
                        <span>
                            <select>
                                <option>

                                </option>
                            </select>
                        </span> 
                        <span>تاريخ الموعد</span>
                    </div>
                    <p className='tripitem hov'><span>ss</span> <span> الحالة المرضية</span></p>
                    <p className='tripitem hov'><span>ss</span><span>المبلغ المراد دفعه</span></p>
                    <p className='tripitem hov'><span>ss</span> <span>المبلغ المتبقي</span></p>
                    <p className='tripitem hov'><span>ss</span><span>المبلغ الكلي</span></p>
                    <p className='tripitem hov'><span>ss</span><span>المقابلة القادمة</span></p>
                    <p className='tripitem hov'><span>ss </span><span>الملاحظات</span></p>
                </div>
            </div>
            <hr style={{width:'100%',marginTop:'5px',marginBottom:'5px'}}/>
            <Link 
                    to={`/login/homeuser`}
                    className='btn' 
                    style={{marginTop:"5px",borderRadius:"5px",
                            width:"80px",textDecoration:'none',
                            paddingTop:''}}
                    // onClick={() => {}}    
                >
                    عودة
            </Link> 
        </div>
    </div>
  )
}

export default Nextreservation